module.exports = __webpack_public_path__ + "img/print-contact.84acec3c.jpg";